import React from 'react';

interface QuoVadisLogoProps {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

// Responsive height classes for each size
const sizeMap = {
  xs: 'h-2 sm:h-6',
  sm: 'h-3 sm:h-8 md:h-10',
  md: 'h-4 sm:h-12 md:h-16',
  lg: 'h-6 sm:h-16 md:h-20 lg:h-24',
  xl: 'h-8 sm:h-20 md:h-24 lg:h-32',
};

export const QuoVadisLogo: React.FC<QuoVadisLogoProps> = ({ size = 'md', className = '' }) => (
  <img
    src={process.env.PUBLIC_URL + '/images/logo-quovadis.png'}
    alt="Logo QUO VADIS"
    className={`mx-auto w-auto max-w-full ${className}`}
    style={{ 
      height: 'auto',
      width: '100px' // Dimensione fissa di 100px di larghezza
    }}
    draggable={false}
  />
); 